module.exports = __webpack_public_path__ + "img/94.9.TU.01740784.png";